<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper" :class="className">
				<div class="modal-container" :style="'width:'+width+'px'" v-click-outside="closeModalFromOutside">
					<div class="modal-header" :class="{'flex_column': subTitle}">
						<h4 class="modal-title font_lg font_bold">{{ title }}</h4>
						<md-button v-if="allowClose"
							class="md-simple md-just-icon md-round modal-default-button"
							@click.stop="closeModal"
						>
							<md-icon>clear</md-icon>
						</md-button>
						<div v-if="subTitle">{{subTitle}}</div>
					</div>
					<div class="modal-body text-center">
						<slot name="body"></slot>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	props: {
		width: { type: [Number, String], default: 500 },
		className: { type: String, default: "" },
		title: String,
		subTitle: String,
		closeOnClickOutside: { type: Boolean, default: true },
		allowClose: { type: Boolean, default: true },
	},
	methods: {
		closeModalFromOutside() {
			if (this.closeOnClickOutside) {
				this.closeModal();
			}
		},
		closeModal: function() {
			this.$emit("close");
		}
	}
};
</script>

<style lang="scss">
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
	opacity: 0;
}

.modal-leave-active {
	opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}
</style>
